import { Stack } from '@mui/material';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useCashBalance } from '../../../../context/CashBalanceContext';
import { FormatCurrency } from '../../../../utils/numbers';
import Spinner from '../../../Spinner';
import { TypographyWallet, TypographyWalletAmount } from '../Layouts/StyledComponentsMenu';

export const WalletOpenDrawer = ({ subItem }) => {
  const { user } = useSelector(state => state.auth);

  const {
    balance: balanceData,
    loading: loadingBalance,
    error: errorBalance,
    refetch: refetchBalance,
  } = useCashBalance();

  useEffect(() => {
    if (user) {
      refetchBalance();
    }
  }, [user, refetchBalance]);

  if (loadingBalance) {
    return <Spinner />;
  }
  if (errorBalance) {
    throw new Error('Error component wallet drawer open');
  }

  const walletAvailability = item => {
    if (item === 'Caja Disponible') {
      return balanceData?.balance ? FormatCurrency(balanceData?.balance) : '$0';
    }
    if (item === 'Dinero en Tránsito') {
      return balanceData?.transitAmount ? FormatCurrency(balanceData?.transitAmount) : '$0';
    }
  };

  return (
    <Stack alignItems='center' justifyContent='center' sx={{ textAlign: 'center', height: '100%' }}>
      <TypographyWallet>{subItem.btnNameSub}</TypographyWallet>
      <TypographyWalletAmount>{walletAvailability(subItem.btnNameSub)}</TypographyWalletAmount>
    </Stack>
  );
};
